import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import BottomNavbar from "../components/BottomNavbar";
import {
  fetchJurnalHarian,
  downloadJurnalHarian,
  hapusJurnalHarian,
} from "../services/jurnalHarianService";
import logo from "../assets/EPRAJOGO1.png";

function JurnalHarian() {
  const navigate = useNavigate();
  const [jurnals, setJurnals] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [tanggalMulai, setTanggalMulai] = useState("");
  const [tanggalSelesai, setTanggalSelesai] = useState("");
  const [downloading, setDownloading] = useState(false);
  const [deletingId, setDeletingId] = useState(null);

  const siswaId = localStorage.getItem("user_id");

  useEffect(() => {
    const loadInitialData = async () => {
      if (!siswaId) return;
      setLoading(true);

      const response = await fetchJurnalHarian(siswaId, 1);
      if (response.success) {
        setJurnals(response.data.data);
        setHasMore(1 < response.data.last_page);
        setPage(1);
      } else {
        console.error(response.message);
      }
      setLoading(false);
    };

    loadInitialData();
  }, [siswaId]);

  const handleLoadMore = async () => {
    const nextPage = page + 1;
    setLoading(true);

    const response = await fetchJurnalHarian(siswaId, nextPage);
    if (response.success) {
      setJurnals((prev) => [...prev, ...response.data.data]);
      setHasMore(nextPage < response.data.last_page);
      setPage(nextPage);
    } else {
      console.error(response.message);
    }

    setLoading(false);
  };

  const handleDownload = async () => {
    if (!tanggalMulai || !tanggalSelesai) {
      alert("Tanggal mulai dan tanggal selesai wajib diisi.");
      return;
    }

    setDownloading(true);

    const result = await downloadJurnalHarian(
      siswaId,
      tanggalMulai,
      tanggalSelesai
    );

    setDownloading(false);

    if (result.success) {
      const url = window.URL.createObjectURL(new Blob([result.blob]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Jurnal_Harian.pdf");
      document.body.appendChild(link);
      link.click();
      link.remove();
      setShowModal(false);
    } else {
      alert(result.message);
    }
  };

  const handleDelete = async (journal) => {
    if (!window.confirm("Hapus jurnal yang diminta untuk direvisi ini?")) return;
    setDeletingId(journal.id);
    const result = await hapusJurnalHarian(journal.id);
    setDeletingId(null);
    if (result.success) {
      setJurnals((current) => current.filter((item) => item.id !== journal.id));
    } else {
      alert(result.message);
    }
  };

  return (
    <main className="app-mobile-page">
      <header className="app-brand-header">
        <div className="app-brand-row">
          <img src={logo} alt="Logo E-Prajogo" className="app-brand-logo" />
          <div><p className="app-brand-name">E-PRAJOGO</p><p className="app-brand-school">SMK NEGERI GUDO</p></div>
          <span className="ms-auto rounded-pill px-3 py-2 small fw-semibold" style={{ background: "#ffffff20", color: "#fff" }}>SISWA</span>
        </div>
        <h1 className="app-header-title">Jurnal Harian</h1>
        <p className="app-header-subtitle">Catatan kegiatan PKL dan status verifikasi dari guru.</p>
      </header>

      <section className="app-content">
        <div className="d-flex justify-content-between align-items-center gap-3 mb-3">
          <div><h2 className="h5 fw-bold mb-1">Riwayat kegiatan</h2><p className="small text-muted mb-0">Lihat, perbaiki, atau unduh jurnalmu.</p></div>
          <button className="btn btn-primary rounded-circle journal-add-button" onClick={() => navigate("/input-jurnal")} title="Tambah Jurnal" aria-label="Tambah jurnal harian">+</button>
        </div>

      {/* Empty State */}
      {jurnals.length === 0 && !loading && (
        <div className="journal-empty-state"><i className="bi bi-journal-text" aria-hidden="true" /><strong>Belum ada jurnal harian</strong><span>Catatan kegiatan PKL yang kamu kirim akan muncul di sini.</span></div>
      )}

      {/* Jurnal List */}
      <div className="list-group">
        {jurnals.map((jurnal) => (
          <article key={jurnal.id} className="journal-entry-card mb-3">
            <div className="d-flex align-items-center justify-content-between gap-2 mb-2">
              <p className="fw-bold mb-0">
                {new Date(jurnal.tanggal).toLocaleDateString("id-ID", {
                  day: "2-digit",
                  month: "long",
                  year: "numeric",
                })}
              </p>
              <span className={`badge rounded-pill px-3 py-2 ${jurnal.status_verifikasi === "disetujui" ? "bg-success-subtle text-success" : jurnal.status_verifikasi === "perlu_revisi" ? "bg-warning-subtle text-warning-emphasis" : "bg-primary-subtle text-primary"}`}>
                {jurnal.status_verifikasi === "disetujui" ? "Disetujui guru" : jurnal.status_verifikasi === "perlu_revisi" ? "Perlu revisi" : "Menunggu verifikasi"}
              </span>
            </div>
            <div className="journal-field"><strong className="journal-field-label">Pekerjaan</strong><span>{jurnal.pekerjaan}</span></div>
            {jurnal.catatan && <div className="journal-field"><strong className="journal-field-label">Catatan kegiatan</strong><span>{jurnal.catatan}</span></div>}
            {jurnal.status_verifikasi === "perlu_revisi" && (
              <>
                {jurnal.catatan_revisi && (
                  <div className="alert alert-warning py-2 mt-3 mb-2">
                    <strong>Catatan revisi:</strong> {jurnal.catatan_revisi}
                  </div>
                )}
                <div className="d-flex gap-2 mt-3">
                  <button
                    className="btn btn-primary btn-sm flex-fill"
                    onClick={() => navigate("/input-jurnal", { state: { journal: jurnal } })}
                  >
                    Perbaiki jurnal
                  </button>
                  <button
                    className="btn btn-outline-danger btn-sm"
                    disabled={deletingId === jurnal.id}
                    onClick={() => handleDelete(jurnal)}
                  >
                    {deletingId === jurnal.id ? "Menghapus…" : "Hapus"}
                  </button>
                </div>
              </>
            )}
          </article>
        ))}
      </div>

      {/* Spinner */}
      {loading && (
        <div className="text-center my-3">
          <div className="spinner-border text-primary" role="status" />
        </div>
      )}

      {/* Load More */}
      {!loading && hasMore && (
        <div className="text-center mt-3">
          <button className="btn btn-outline-primary" onClick={handleLoadMore}>
            Tampilkan Lebih Banyak
          </button>
        </div>
      )}

      {/* Download Button */}
      <button
        className="journal-download-button"
        onClick={() => setShowModal(true)}
      >
        <i className="bi bi-download me-2"></i> Download
      </button>

      {/* Modal */}
      {showModal && (
        <div
          className="modal d-block"
          style={{
            backgroundColor: "rgba(0,0,0,0.5)",
            position: "fixed",
            top: 0,
            left: 0,
            zIndex: 9999,
            width: "100%",
            height: "100%",
          }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content journal-modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Download Jurnal Harian</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label">Tanggal Mulai</label>
                  <input
                    type="date"
                    className="form-control"
                    value={tanggalMulai}
                    onChange={(e) => setTanggalMulai(e.target.value)}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Tanggal Selesai</label>
                  <input
                    type="date"
                    className="form-control"
                    value={tanggalSelesai}
                    onChange={(e) => setTanggalSelesai(e.target.value)}
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Batal
                </button>
                <button
                  className="btn btn-primary"
                  onClick={handleDownload}
                  disabled={downloading}
                >
                  {downloading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      />
                      Memproses...
                    </>
                  ) : (
                    "Download PDF"
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      </section>
      <BottomNavbar />
    </main>
  );
}

export default JurnalHarian;
